export default "__VITE_ASSET__pIHwYLoH__"